export const Environment = {
  PROD: 'PROD',
  BETAPROD: 'BETAPROD',
  TIP: 'TIP',
  SI: 'SI',
  BETASI: 'BETASI',
  CI: 'CI',
};

// domains with 'ui.' are for main bundle
// domains without 'ui.' are for signup bundle
export const Domains = {
  PROD: {
    UI: {
      ADS: 'ui.ads.microsoft.com',
      BINGADS: 'ui.bingads.microsoft.com',
      BETA: {
        ADS: 'ui.beta.ads.microsoft.com',
        BINGADS: 'ui.beta.bingads.microsoft.com',
      },
      TIP: {
        ADS: 'ui.tip.ads.microsoft.com',
        BINGADS: 'ui.tip.bingads.microsoft.com',
      },
    },
    ADS: 'ads.microsoft.com',
    BINGADS: 'bingads.microsoft.com',
    BETA: {
      ADS: 'beta.ads.microsoft.com',
      BINGADS: 'beta.bingads.microsoft.com',
    },
    TIP: {
      ADS: 'tip.ads.microsoft.com',
      BINGADS: 'tip.bingads.microsoft.com',
    },
    SDK: {
      ADS: 'sdk.ads.microsoft.com',
      TIP: 'sdktip.ads.microsoft.com',
      BETA: 'sdkbeta.ads.microsoft.com',
    },
  },
  TEST: {
    UI: {
      ADSINT: 'ui.ads-int.microsoft.com',
      SI_PROXY: 'app1.ui.ads-int.microsoft.com:12000',
      SI: 'ui.si.bingads.microsoft.com',
      BETA: {
        ADSINT: 'ui.beta.ads-int.microsoft.com',
        SI: 'ui.beta.si.bingads.microsoft.com',
      },
    },
    ADSINT: 'ads-int.microsoft.com',
    SI_PROXY: 'app1.ads-int.microsoft.com:12000',
    SI: 'si.bingads.microsoft.com',
    BETA: {
      ADSINT: 'beta.ads-int.microsoft.com',
      SI: 'beta.si.bingads.microsoft.com',
    },
    LOCAL: 'localhost',
    CI: 'ci.ads.microsoft.com',
    SDK: {
      ADSINT: 'sdk.ads-int.microsoft.com',
      BETA: 'sdkbeta.ads-int.microsoft.com',
    },
  },
};

/**
 * Determines what environment the site is running in, based on the domain.
 * @param {string} domain - Current domain.
 * @returns {string} - Environment the site is running in.
 */
export function getEnvironment(domain) {
  const prodBingAdsPattern = /^(ui\.)?bingads\.microsoft\.com$/;
  const prodMicrosoftAdsPattern = /^(ui\.)?ads\.microsoft\.com$/;
  if (domain.match(prodMicrosoftAdsPattern) || domain.match(prodBingAdsPattern)) {
    return Environment.PROD;
  }

  const betaprodBingAdsPattern = /^(ui\.)?beta\.bingads\.microsoft\.com$/;
  const betaprodMicrosoftAdsPattern = /^(ui\.)?beta\.ads\.microsoft\.com$/;
  if (domain.match(betaprodMicrosoftAdsPattern) || domain.match(betaprodBingAdsPattern)) {
    return Environment.BETAPROD;
  }

  const tipBingAdsPattern = /^(ui\.)?tip\.bingads\.microsoft\.com$/;
  const tipMicrosoftAdsPattern = /^(ui\.)?tip\.?ads\.microsoft\.com$/;
  if (domain.match(tipBingAdsPattern) || domain.match(tipMicrosoftAdsPattern)) {
    return Environment.TIP;
  }

  const siBingAdsPattern = /^(ui\.)?si\.bingads\.microsoft\.com$/;
  const siMicrosoftAdsPattern = /^(app1\.)?(ui\.)?ads-int\.microsoft\.com(:12000)?$/;
  if (domain.match(siMicrosoftAdsPattern) || domain.match(siBingAdsPattern)) {
    return Environment.SI;
  }

  const betasiBingAdsPattern = /^(ui\.)?beta\.si\.bingads\.microsoft\.com$/;
  const betasiMicrosoftAdsPattern = /^(ui\.)?beta\.ads-int\.microsoft\.com$/;
  if (domain.match(betasiMicrosoftAdsPattern) || domain.match(betasiBingAdsPattern)) {
    return Environment.BETASI;
  }

  return Environment.CI;
}

/**
 * Checks if domain is Prod or TIP domain.
 * @param {string} domain - Current domain.
 * @returns {bool} - True if Prod or TIP.
 */
export function isProdEnvironment(domain) {
  const env = getEnvironment(domain);
  return env === Environment.PROD || env === Environment.BETAPROD || env === Environment.TIP;
}

/**
 * Checks if domain is an internal environment like SI or CI or local.
 * @param {string} domain - Current domain.
 * @returns {bool} - True if not Prod or TIP.
 */
export function isInternalEnvironment(domain) {
  return !isProdEnvironment(domain);
}

export function isSiEnvironment(domain) {
  const env = getEnvironment(domain);
  return env === Environment.SI || env === Environment.BETASI;
}

export function getIsSignUpBundle(pathName) {
  return !!pathName.match(/signup/);
}

export function getRootUrl(domain) {
  const env = getEnvironment(domain);
  switch (env) {
    case Environment.PROD:
      return `https://${Domains.PROD.ADS}`;
    case Environment.BETAPROD:
      return `https://${Domains.PROD.BETA.ADS}`;
    case Environment.TIP:
      return `https://${Domains.PROD.TIP.ADS}`;
    case Environment.SI:
      return `https://${Domains.TEST.ADSINT}`;
    case Environment.BETASI:
      return `https://${Domains.TEST.BETA.ADSINT}`;
    default:
      return `https://${Domains.TEST.CI}`;
  }
}
